import type { Invoice } from 'walden-fast/types/invoice';
import type { Factory } from 'walden-fast/types/mocks';
import { selectRandom } from './lists';

const MOCK_INVOICE: Invoice = {
  id: '1',
  dueDate: new Date(1732721945000),
  status: 'paid',
  description: 'Monthly invoice',
  subscription: 'Basic',
  total: 450,
  currency: 'EUR',
};

export const invoiceFactory: Factory<Invoice> = (overrides) => ({
  ...MOCK_INVOICE,
  dueDate: new Date(1733750902000 + (Math.random() - 0.5) * 1000000000),
  status: selectRandom(['paid', 'pending']),
  ...overrides,
});
